<template>
  <div class="protocal-con">
    <protocol
      :footer="footer"
      :content="content"
    />
  </div>
</template>

<script>
  import protocol from 'components/protocol'
  import { bridge } from 'mixins'

  export default {
    mixins: [bridge],
    components: {
      protocol
    },
    data() {
      return {
        content: [
          {
            text: '为更好得向您提供充值服务，在接受本协议之前，请服务使用人（以下称“用户”或“您”）务必认真阅读本协议，<strong>特别是免除或限制责任的条款（以粗体下划线标识）应重点阅读。如有任何异议，请不要进行后续操作，请及时与平台沟通商议。如您自主选择按照页面提示进行充值，则视为您对协议全部及任何内容的认可，并同意接受本协议项下各项条款的约束。</strong>',
          },
          {
            text: '若您为未成年人，请委托监护人操作或在监护人明示同意下操作，否则请勿使用本充值服务。'
          },
          {
            title: '一、功能规则',
            text: [
              '1、“鲸币”是壹心理向您提供的用于在本平台上进行相关消费的虚拟币，您可以用“鲸币”购买虚拟礼物，并将购买的虚拟礼物赠予（打赏）给壹心理主播。“鲸币”充值数额由用户自行决定，<strong>“鲸币”购买后，不可撤回，不能兑换为人民币，请您务必根据自身实际需求购买相应数量的“鲸币”。</strong>',
              '<strong>2、充值过程中，请您务必仔细确认自己的账号并选择相关操作选项。若因您自身未确认好充值账号、操作失误等造成充错账号，错选充值金额等而导致自身权益受损的，由此带来的损失由您自行承担，壹心理不做任何补偿或赔偿。</strong>',
              '<strong>3、“鲸币”充值是壹心理因业务运营需要提供的一次性服务，“鲸币”并非存款、预付款或其他可无理由退还性质的商品或财产权利。用户充值成功后，壹心理的充值服务即提供完毕，壹心理不再提供逆向兑换或转让服务，且无正当理由壹心理亦不提供退还服务（正当理由指壹心理停止运营或停止向用户提供“鲸币”及所有“鲸币”相关功能、服务，或法律法规明确规定壹心理应该退还），请您务必在具体操作前谨慎选择。</strong>',
              '<strong>4、如发现因系统故障或其他任何原因导致的充值错误，壹心理都有权以电子邮件、短信、私信或其他合理方式通知您后纠正该错误。如该错误导致您实际收到的“鲸币”数量少于您应获得的“鲸币”，则壹心理会尽快将差额补足至您的账户中。如果该错误导致您实际收到的“鲸币”数量多于您应获得的“鲸币”，则壹心理有权从您的账户中直接扣除差额。</strong>'
            ]},
          {
            title: '二、协议效力',
            text: '本协议适用于壹心理哆啦dola直播打赏功能服务，其作为壹心理《注册用户协议》的补充协议，是壹心理《注册用户协议》的不可分割的重要组成部分，具有同等的法律效力。若本协议与壹心理《注册用户协议》约定不一致的，以本协议约定为准。本协议没明确规定的，则仍以壹心理《注册用户协议》为准。'
          },
          {
            title: '三、权利声明',
            text: [
              '1、您理解并同意，壹心理有权基于交易安全等方面的考虑，不时设定涉及交易的相关事项，包括但不限于交易限额、交易次数等。',
              '<strong>2、为保证用户体验和服务安全，壹心理有权决定“鲸币”的适用范围和条件等。</strong>',
              '<strong>3、因您自身的原因导致壹心理无法提供“鲸币”购买服务或提供“鲸币”购买服务时发生任何错误而产生的任何损失或责任，由您自行负责。壹心理不承担责任。包括但不限于：</strong>',
              '<strong>(1）违背国家法律法规的；</strong>',
              '<strong>(2）因您的壹心理账号失效、丢失、被封停；</strong>',
              '<strong>(3）因您绑定的第三方支付机构账户的原因导致的损失或责任，包括您使用未经认证的第三方支付账户或使用非您本人的第三方支付账户，您的第三方支付账户被冻结、查封等；</strong>',
              '<strong>(4）您将密码告知他人导致的财产损失；</strong>',
              '<strong>(5）因您个个人的故意或重大过失所造成的财产损失。</strong>'
            ]
          },
          {
            title: '四、违约处理',
            text: '用户在使用壹心理提供的充值服务时，如出现任何的涉嫌违法犯罪、违反社会主义道德风尚、违反壹心理《注册用户协议》、本协议或其他本平台对用户的管理规定的情形，<strong>壹心理有权视您行为的性质及严重程度，随时中断或终止向您提供本协议下的网络服务，或者对您的账号采取暂时或永久禁封措施。账号封禁后至解禁（如有）前，您账户上剩余的“鲸币”将被暂时冻结或前部扣除，不可继续用于购买本平台的产品或服务，同时不予返还您购买“鲸币”时的现金价值。</strong>'
          },
          {
            title: '五、纠纷解决',
            text: [
              '1、本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理，并以广东省广州市天河区人民法院为管辖法院。',
              '2、如本协议的任何条款被视作无效或无法执行，则上述条款可被分离，其余部分则仍具有法律效力。'
            ]
          }
        ],
        footer: '壹心理平台于2020年8月3日发布并执行'
      }
    },
    mounted() {
      this.setNavTitle('壹心理用户充值协议')
    }
  }
</script>

<style lang="scss" scoped>
  .protocal-con {
    padding: 48px 0;
    min-height: 100vh;
    background-color: #fff;
  }
</style>
